/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2023-11-30 12:00:04
 * @LastEditors: Vincent.Zhu
 * @Description:
 * @FilePath: \tofba-client\src\lang\en.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
export default {
  route: {
    waybillManagement: 'Waybill',
    waybillList: 'List',
    orderToAirFreight: 'Air',
    orderToSeaFreight: 'Ocean',
    orderToExpressDelivery: 'Express',
    pickupInformation: 'Pickup',
    addAirSeag2gwaybill: 'Port To Port',
    waybillDetails: 'Detail',
    overseasWarehouse: 'Overseas Warehouse',
    endWaybill: 'End',
    smallParcelWaybill: 'Small Parcel Waybill',
    smallParcelWaybillDetails: 'Small Parcel Waybill Details',
    abroadWaybill: 'Abroad',
    systemHelp: 'System',
    myProfile: 'Profile',
    amazon: 'Amazon',
    abroadWaybillList: 'List',
    financialManagement: 'Finance',
    freightInquiry: 'Calculate',
    systemInformation: 'Message',
    orderToBatch: 'Order To Batch',
    overseasWarehouseWaybill: 'Overseas Warehouse Waybill',
    pendingWaybill: 'Confirm',
    orderToAbroadWaybill: 'Create',
    OMS: 'OMS',
    orderToOverseasWarehouse: 'Order To Overseas Warehouse',
    //
    dashboard: 'Dashboard',
    invoiceTitle: 'Invoice Title',
    contactUs: 'Contact Us',
    quickOrderGuidance: 'FBA Quick Order Guide',
    // finance
    quickRepayment: 'Repayment',
    flowRecord: 'Record',
    // Profile
    skuInfo: 'SKU Library',
    storeManagement: 'Amazon Store',
    pickupAddress: 'Pickup Address',
    shippingAddress: 'ShipTo Address',
    manageOtherFiles: 'Manage Other Files',
    senderInformation: 'ShipFrom Address',
    importerInformation: 'Importer Address',
    invoiceTitle: 'Invoice Title',
    trackingNotificationSettings: 'Track Notice Mailbox',
    customerProfileEmailNotification: 'File Notice Mailbox',
    overseasWarehouseTrackingNotificationSettings: 'Oversea Notice Mailbox',
    // Amazon
    inbound: 'Inbound',
    planlist: 'Plan List',
    endWaybillList: 'List',
    endOrderToAirFreight: 'Air',
    endOrderToShipping: 'Ocean',
    waybillHdDetail: 'Detail',
    historyPrice: 'History Price',
    quotationList: 'Quotation List',
    file: 'File',
    warehouseInfoMaintenance: 'warehouse Info Maintenance',
    sendWaybillDetail: 'Send Waybill Detail',
  },
  navbar: {
    logOut: 'Log Out',
    password: 'Change PassWord'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips:
      'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  /**
   * 首页信息
   */
  dashboard: {
    waybillSummary: 'Summary',
    financialCenter: 'Finance',
    newsCenter: 'News',
    waybillList: 'Recent',
    fastRepayment: 'Repayment',
    balance: 'Balance',
    amountOwed: 'Amount',
    accountMnager: 'Account Mnager',
    serviceManager: 'Service Manager',
    website: 'Website',
    financialServices: 'Financial Services',
    abroadSystem: 'Abroad System',
    index: 'Index',
    waybillNo: 'No',
    referenceNo: 'Ref',
    status: 'Status',
    operate: 'Operate',
    partner: 'Partner',
    bill_tips:
      'The bill status of the port of departure, gray has not been billed; green has billed',
    dashboard_tips:
      'The cross-border payment rate is 0 to 0.3%. The 17-year cross-border payment brand under Ant Group is safe and secure.',
    wanlihui: 'Wanlihui',
    search_content: 'Please enter content',
    waybill_no_required: 'Please enter the waybill No',
    reference_no_required: 'Please enter the Ref no',
    importReturnInfo: 'Import Return Info',
    exportReturnInfo: 'Export Return Info',
  },
  waybill: {
    waybillAll: 'All',
    waitForConfirm: 'Confirm',
    waitForDealSend: 'DealSend',
    waitForOutStock: 'OutBound',
    waitForToThePort: 'Arrival Port',
    waitForSign: 'Pending receipt',
    alrSeadySigned: 'Signed',
    alrSeadyReturned: 'Returned',
    problematic: 'Problem Piece',
    already_close: 'Closed',
    wait_for_confirm: 'Draft',
    wait_for_deal_send: 'Confirm',
    wait_for_in_stock: 'Inbound',
    wait_for_out_stock: 'OutBound',
    wait_for_on_line: 'Online',
    wait_for_clearance_of_goods: 'Export Declarations', // 报关
    customs_inspecting: 'Customs Inspection',
    wait_for_permitthrough: 'Customs clearance', // 报关放行
    wait_for_leaveport: 'Pending departure',
    wait_for_arrivalport: 'Arrival Port',
    wait_for_cclearance: 'Customs clearance',
    cclearance_inspecting: 'Customs clearance inspection',
    wait_for_clearancerelease: 'Pending customs clearance',
    wait_carry_cabinet: 'Carry Cabinet',
    wait_for_arrivalstock: 'Arrival Stock',
    wait_for_dispatch: 'Delivering',
    part_of_sign: 'Part Sign',
    wait_for_sign: 'Signed',
    wait_for_lock: 'Locked',
    already_finish: 'Finished',
    already_freeze: 'Freeze',
    already_returned: 'Returned:',
    discharging_port: 'discharging port',
    unload_a_ship: 'unload ship',
    __sea__: '海运',
    __air__: '空运',
    __seaandair__: '海运+空运',
    quickOrder: 'Quick Order',
    fastOrder: 'Fast Order',
    standardOrder: 'Common Order',
    upExcelTitle: 'Upload Packing List',
    selectChannel: 'Select Channel',
    selectSender: 'Select ShipFrom',
    selectImporter: 'Select Importer',
    customsClearanceInvoice: 'Liquidation Invoice',
    customsClearanceInvoiceTips:
      'Please note that the purchase unit price currency is inconsistent with the reporting currency',
    ThePackingList: 'Packing List',
    loadingPort: 'Departure required',
    customer: 'Customer',
    customer_info: 'Customer Info',
    customer_hope: 'Potential customer',
    country_not_null: 'Country required',
    customer_importer_attn_not_null: 'Importer Contact required',
    customer_importer_phone_not_null: 'Importer Phone required',
    address_not_null: 'Address Required',
    address_not_contain_chinese: 'Address Can not contain Chinese',
    vat_not_null: 'VAT required',
    vat_exists: 'VAT Exist ',
    eori_exists: 'EORI required',
    link_man_not_null: 'Contact required',
    contact_way_not_null: 'Contact phone required',
    default_value_not_null: 'Default value required',
    state_value_not_null: 'State required',
    city_not_null: 'City required',
    area_not_null: 'Districts and counties required',
    zip_code_not_null: 'PostalCode required',
    customer_login_name_exists: 'Customer login name exist',
    customer_regist_phone_exists:
      'Customer registered mobile phone number already exists',
    customer_name_short_exists: 'Customer short name exist',
    customer_name_full_exists: 'Customer full name exist',
    customer_enterprise_creditcode_exists:
      'Business credit code already exists',
    customer_delivery_company_not_null: 'Company Name required',
    customer_delivery_address_attn_not_null: 'Contact required',
    customer_delivery_address_phone_not_null: 'Contact phone required',
    customer_delivery_address_not_null: 'Address required',
    customer_delivery_city_not_null: 'City required',
    customer_delivery_state_not_null: 'State required',
    customer_delivery_country_not_null: 'Country required',
    customer_delivery_zipcode_not_null: 'PostalCode required',
    customer_not_contain_chinese: 'Company Name cannot Chinese is not allowed',
    sku_exists: 'SKU Exist',
    sku_not_null: 'SKU required',
    declare_namecn_not_null: 'Chinese product name required',
    declare_nameen_not_null: 'English product name required',
    brand_not_null: 'Brand required',
    material_not_null: 'Material required',
    purpose_not_null: 'Purpose required',
    customsCode_not_null: 'Hs Code required',
    declareValue_not_null: 'Declare value required',
    purchasing_price_not_null: 'Purchasing price required',
    measurement_unit_not_null: 'Measurement Unit required',
    business_license_picurl_must_upload: 'Please upload business license',
    finance_email_must_input:
      'Email required, Split multiple mailboxes by semicolon',
    password_connot_equals_loginname:
      'The password cannot be the same as the login name',
    bt_mess_update_airshippingerrorrange:
      'Batch Modify Air Freight Error Range',
    bt_mess_update_oceanshippingerrorrange: 'Batch modify shipping error range',
    bt_mess_export_all_customerinfo: 'Export Customer All Info',
    bt_mess_export_customerinfo: 'Export Customer',
    upload_customer_sku_excel_poi_error: 'Excel analyze Error',
    excel_template_no_data: 'Excel template No Data',
    template_data_illegal_please_make_sure_each_sku_has_pic:
      'The template data is illegal, please ensure that each SKU has a corresponding image or do not overlap the SKU image coordinates',
    save_fail: 'Save Fail',
    save_success: 'Save Success',
    customer_sku_infos_collection_is_empty: 'No data to update',
    sku_can_not_blank: 'SKU required',
    sku_is_repeat_in_this_template: 'Duplicate in SKU template',
    sku_is_repeat_in_database: 'Duplicate SKU in template',
    sku_declare_name_en_is_blank: 'SKU declare nameEn required',
    sku_declare_name_cn_is_blank: 'SKU declare nameCn required',
    sku_brand_is_blank: 'SKU brand required required',
    sku_material_is_blank: 'SKU material ',
    sku_purpose_is_blank: 'SKU purpose required',
    sku_customs_code_is_blank: 'SKU HS Code required',
    sku_declare_value_is_blank: 'SKU declare value required',
    sku_purchasing_price_is_blank: 'SKU purchasing price required',
    sku_is_charged_is_blank: 'SKU is charged required',
    measurement_unit_blank_tips: 'The SKU unit required',
    measurement_unit_error:
      'The SKU unit is incorrectly filled in, only one or a set is allowed',
    per_suit_num_tips: 'The unit is set, the number of each set is required',
    customer_no_data: 'No Data',
    user_id_not_null: 'User ID required',
    invoice_name_not_null: 'Invoice Name required',
    invoice_type_not_null: 'Invoice Type required',
    invi_identifica_number_not_null: 'Taxpayer identification required',
    is_default_not_null: 'Is Default Required',
    invoice_receive_phone_format_error: 'Notifier phone number format error',
    invoice_receive_email_format_error: 'Notifier email format error',
    email_exist: 'Email Exist',
    email_not_null: 'Email required',
    each_customer_only_can_create_ten_email:
      'Each customer is allowed to create up to 10 mailboxes',
    print_label_fail: 'Print Label Fail',
    box_no_is_not_exit: 'BoxNo Not Exist',
    export_track_number: 'Export TrackNumber',
    order_label_not_exit: 'This order has not yet received a tracking label',

    batch_send_confirm: 'Bulk delivery',
    combined_customs_declaration: 'Combined customs declaration',
    cancel_combined_customs_declaration: 'Cancel the combined declaration',
    batch_print_label: 'Batch print of waybill label',

    batch_print_label_tips:
      'Please select the preview printing method (print 6 labels per page on A4 paper)',
    cancel_abroad_waybillNo: 'Cancel transit order',
    abroad_waybill_create: 'Transit order',
    bill_tips:
      'The bill status of the port of departure, gray has not been billed; green bill has been issued',
    pva_tips: 'Whether customs clearance deferred variable, gray no, black yes',
    merge_declaration_tips: 'Merge declarations',
    detail: 'Detail',
    copy: 'Copy',
    download_packinglist: 'Download uploaded packing list',
    download_tracking_number :  'Download Packing List Tracking Number',
    print_preview_tips: 'Print Preview',
    colReturn: 'Call back for confirmation',
    uploadCustomsInfo: 'Upload customs declaration information',
    uploadCDA: 'Upload CDA data',
    inbound_data: 'Inbound order',
    download_tips:
      'The file download page has been opened for you, if the page does not jump, please check whether the pop-up window is blocked by the browser',
    transfer_cancel_aborad_waybill_tips: 'Whether to cancel the transfer order',
    transfer_aborad_waybill_tips: 'Whether to place a transfer order',
    boxNo: 'BoxNo',
    trackNumber: 'TrackNumber',
    weight: 'Weight',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    totalVolum: 'Volume',
    volumeWeight: 'volume Weight',
    chargedWeight: 'charged Weight',
    summary: 'Total',

    invoice_tips:
      'Please note that the purchase unit price currency is inconsistent with the declaration currency',
    import_invoice_tips: 'Import Invoice',
    restore_invoice_tips:
      'This function can only restore the latest invoice data of the current computer. ',
    restoreInvoiceData: 'Restore Invoice',
    showSkuList: 'Select SKU',
    upLoadImg: 'Upload SKU Image',
    bulk_upload_price_screenshots: 'Bulk upload price screenshots',
    batch_upload_screenshots_of_earnings:
      'Batch upload screenshots of earnings',
    resetInvoice: 'Reset invoice content',
    declareValueCurrency: 'Currency',
    addEmptyData: 'Add product name',
    uploadInvoice: 'Batch import packing list invoices',
    fba_template: 'Template (suitable for FBA order)',
    no_fba_template: 'Template(suitable for non-FBA orders)',
    fbc_template: 'Template (suitable for FBC order)',
    sku_same_template:
      'Template (suitable for non-FBA, order with the same sku)',
    japan_line_template: 'Template (suitable for Japanese online order)',
    quick_template:
      'Template (convenient order placement (packing list invoice))',
    upload_invoice_tips1:
      'If there is a new template imported, if there are multiple SKUs with the same box number, box number, length, width, height, and re-arrange, please merge the cells;',
    upload_invoice_tips2:
      'Please check the template data carefully when uploading, FBA needs to fill in Shipment ID, Reference ID;',
    upload_invoice_tips3:
      'If the system receives customer SKU information, it will automatically fill in some missing parts',
    upload_invoice_text1: 'Drag file here, or',
    upload_invoice_text2: 'Click to upload',
    upload_invoice_text3: 'Supports uploading multiple files at the same time',
    upload_invoice_text4:
      'Please upload the customs declaration information in time. If it is not uploaded in time, the system will deduct the goods. ',
    upload_server: 'Upload to server',
    quickOrderGuidance:
      'Please directly upload the delivery schedule (EXCEL format) exported from Amazon seller background. One-click upload, automatic completion of invoice and packing list filling. If in doubt, please',
    blank: 'Click Here',
    uploadExcel: 'Please upload EXCEL',
    continue_upload: 'Continue uploading',
    select_file: 'Select file',
    upload_order_template: 'Upload convenient order template',
    download_order_template: 'Download import template (portable order)',
    wait_return_cabinet:'Wait Return Cabinet',
    wait_unloading_cabinet:'Wait Unloading Cabinet',
    merge_customs_clearance: 'merge customs clearance',
    cancel_merge_customs_clearance: 'cancel merge customs clearance',
  },
  endWaybill: {
    customsClearanceAndSend: 'customs clearance and send',
    customsClearance: 'customs clearance',
    expressDelivery: 'express delivery',
    truckDelivery: 'truck delivery',
    consolidatedOrderInformation: 'Consolidated order Info',
    title: 'Combined order Info',
    title2: 'Basic Info'
  },
  /**
   * 下单指引
   */
  system: {
    guide: 'FBA Quick order guide'
  },
  guide: {
    title: 'FBA Quick Order Shipment Plan Packing List Obtaining Guidelines'
  },
  /**
   * 消息
   */
  message: {
    content: 'Content',
    status: 'Status',
    cdate: 'CreateTime',
    bulkread: 'Bulk read'
  },
  /**
   * 查价
   */
  price: {
    title: 'Shipping Calculate',
    loadingPrice: 'Place of shipment',
    country: 'Destination country',
    weight: 'Weight',
    volumn: 'Volumn',
    channelAbility: 'ChannelAbility',
    specialProduct: 'Special Product',
    isTaxFarming: 'Tax',
    deliveryTerms: 'DeliveryTerms',
    query: 'Query',
    reset: 'Reset'
  },
  /**
   * 公共表单组件
   */
  form: {
    query: 'Query',
    reset: 'Reset',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create'
  },
  channel: {
    waybillNo: 'Waybill No',
    fbaCode: 'FBA Code',
    trackNumber: 'Track Number',
    declareNameCn: 'Name(CN)',
    loadingPort: 'Place of shipment',
    countryId: 'Country',
    customerActualWeight: 'Weight(KG)',
    customerTotalPackages: 'PCS',
    customerVolume: 'Volume(CBM)',
    purposeWarehouseType: 'Warehouse Type',
    dispatcher: 'Company Or Individual',
    dispatchLinkMan: 'Contact',
    dispatchPhone: 'Phone',
    dispatchEmail: 'Email',
    dispatchProvince: 'State',
    dispatchCity: 'City',
    dispatchZipCode: 'PostalCode',
    dispatchAddress: 'AddressLine1',
    dispatchAddress2: 'AddressLine2',
    customerDispatchAddress: 'Common Delivery Address',
    saveCustomerDispatchAddress: 'Save',
    dispatchAddressCode: 'Delivery Address',
    deliveryNumber: 'Warehouse Number/Link',
    deliveryFiles: 'dispatch Document',
    channelCapacity: 'Channel Capacity',
    specialProduct: 'Special Product',
    isTaxFarming: 'Tax',
    deliveryTerms: 'DeliveryTerms',
    isCustomerDeclaration: 'CustomerDeclaration',
    inStockChannel: 'Channel',
    cabinetNumber: 'Cabinet Number',
    deliveryType: 'Delivery Type',
    provinceId: 'Domestic Division',
    isPVA: 'Postponed VAT Accounting',
    finalWeight: 'Estimated Weight',
    feightMoney: 'Estimated Shipping',
    isChinaAustraliaCard: 'Making China-Australia certificate',
    selfDelivered: 'Delivery Method',
    pickup: 'Pickup',
    dropoff: 'Dropoff',
    isBuyInsurance: 'Purchase Insurance',
    etInStock: 'Warehousing Time',
    customerRemark: 'Remark',
    selectLabel: 'Please Select',
    loadingPort_tooltip: 'Click to fill in to quickly search',
    yes: 'Yes',
    no: 'No',
    selectFile: 'Select File',
    channelTips: 'Channel surcharges and how-tos',
    common_delivery_address: 'Select Common Delivery Address',
    et_inStock_tip:
      'If the delivery is not within the estimated warehousing time period, you need to contact the corresponding sales in advance and notify the warehouse to prepare for receipt',
    selectDate: 'Select date',
    selectDatePeriod: 'Select time period',
    isTaxFarming_tooltips: 'Do you choose our company tax package channel?',
    ddu:
      'It means that you have your own importer in the destination country and pay the customs duties yourself in the destination country (ie: customs duties collect);',
    ddp:
      'It means that you have your own or no importer in the destination country, and our company needs to pay the customs in advance (ie: customs prepaid)',
    default_ddp:
      'If you choose our company tax-included channel, the delivery terms default to DDP',
    ddu_1:
      'The importer/consignee pays tax in the destination country',
    ddp_1:
      'The shipper pays tax in the non-destination country',
    default_ddp_1:
      'If you choose our company tax-included channel, the delivery terms default to DDP',
    customs_declaration_data_upload: 'Customs declaration data upload',
    feight_money_tips:
      'The shipping fee is for reference only, the actual charge is based on our warehousing data as the billing standard',
    customer_declaration_content:
      'It refers to the situation where you designate a company with import and export rights for export declaration, can provide a complete set of customs declaration documents by yourself, and do export tax rebates in the future. Please select yes. If this is not the case, please select No.',
    customs_declaration_materials:"If the customs declaration data of the customer has been reviewed, the customs declaration cannot be modified and the customs declaration data cannot be uploaded",
    referenceNo: 'Ref No.',
    reference_no_tips:
      'Any number that you can use to identify this waybill yourself.',
    reference_no_require:
      'Please fill in English, numbers or -, no more than 50 characters',
    arrivalTotalPackages: 'PCS to warehouse',
    quickly_search: 'Click enter for a quick search',
    dispatch: 'ShipTo',
    customerFee: 'Declare the freight',
    warehousing_time: 'warehousing time'
  },
  /**
   * 发件人
   */
  sender: {
    create: 'New sender company',
    select: 'Select sender company',
    companyNameCn: 'Company(Chinese)',
    companyNameEn: 'Company(English)',
    contact: 'Contact',
    phone: 'Phone',
    address: 'Address',
    zipCode: 'PostalCode',
    enterpriseCreditCode: 'Tax ID',
    input_companyNameCn: 'Please fill in the sender company(Chinese)',
    input_companyNameEn: 'Please fill in the sender company(English)',
    input_contact: 'Please fill in the Contact',
    input_phone: 'Please fill in the Address',
    input_zipCode: 'Please fill in the PostalCode',
    input_enterpriseCreditCode: 'Please fill in the Tax ID',
    input_address: 'Please fill in the Address'
  },
  /**
   *Packing List
   */
  packing_list: {
    reset: 'Reset PackingList',
    boxRule: 'Box number rule',
    startNum: 'Start box number',
    endNum: 'End box number',
    selectSku: 'Select SKU',
    batchDelte: 'Batch delete',
    batchEdit: 'Batch Edit',
    startNum_required: 'Please fill in the starting box number',
    endNum_required: 'Please fill in the end box number',
    boxNum: 'Box number',
    grossWeight: 'Gross weight per box',
    select_sku: 'Select SKU',
    delete_sku: 'Batch delete',
    batch_edit: 'Batch edit',
    cartonNo: 'Carton number',
    grossWeight: 'Gross weight per box',
    declareNameCn: 'Product name(CN)',
    skuNum: 'Qty',
    remain: 'Remain number',
    LWH: 'Single box length X width X height',
    tips1:
      'According to the requirements of the customs of the importing and exporting countries, the packing list must make sure that the box number of each box corresponds exactly to the SKU number of the products contained in the box. ',
    tips2:
      'If the declared packing details do not match the actual packing details, you may be responsible for delays, customs deductions or even fines when encountering customs inspections! ',
    startNum_tips1:
      'The starting box number is 1. If the end box number is not filled in, the data of 1 box will be filled in. ',
    startNum_tips2:
      'If the starting box number is 1 and the end box number is 1, it is to fill in the data of 1 box. ',
    startNum_tips3:
      'The starting box number is 1 and the end box number is 2, then fill in the data of 2 boxes. ',
    skuNum: 'Total number',
    inputNum: 'Please fill in the number',
    boxed_num: 'Number of boxes to be loaded',
    lwh: 'L×W×H(CM)'
  },
  /**
   * 校验规则
   */
  rules_message: {
    loadingPort: 'Please select Place of shipment',
    countryId: 'Please select Country',
    dispatchAddressCode: 'Please select Delivery Address',
    customerActualWeight: 'Please fill in the weight',
    customerVolume: 'Please fill in the volume',
    customerTotalPackages: 'Please fill in the PCS',
    purposeWarehouseType: 'Please select warehouse type',
    isPVA: 'Please choose PVA',
    channelCapacity: 'Please select a channel capability, at least one',
    specialProduct: 'Please select a special product, at least one',
    isTaxFarming: 'Please choose whether to include tax',
    deliveryTerms: 'Please select delivery terms',
    isCustomerDeclaration: 'Please choose whether to declare',
    inStockChannel: 'Please select a channel',
    deliveryType: 'Please select delivery method',
    provinceId: 'Please select a domestic division',
    isChinaAustraliaCard:
      'Please choose whether to entrust the production of the China-Australia Certificate',
    selfDelivered: 'Please select a pickup method',
    isBuyInsurance: 'Please choose whether to purchase insurance',
    dispatcher: 'Please fill in Company Or Individual',
    dispatchLinkMan: 'Please fill in the contact',
    dispatchPhone: 'Please fill in the contact number',
    dispatchEmail:
      'Please fill in the email address, multiple emails; separate, fill in up to 4 emails',
    dispatchAddress: 'Please fill in address 1',
    dispatchAddress2: 'Please fill in address 2',
    dispatchProvince: 'Please fill in the state',
    dispatchCity: 'Please fill in the citu',
    positive_integer: 'Please fill in a positive integer',
    number_formate: 'Must be a number with 3 decimal places'
  },
  /**
   * SKU
   */
  sku: {
    declareNameEn: 'Product Name(EN)',
    declareNameCn: 'Product Name(CN)',
    batchImportSku: 'Batch Import SKU',
    batchExportSku: 'Batch Export SKU',
    create: 'Create SKU',
    edit: 'Edit SKU',
    batchCreate: 'Batch Create SKU',
    brand: 'Brand',
    material: 'Material',
    purpose: 'Purpose',
    model: 'Model',
    measurementUnit: 'Unit',
    perSuitNum: 'Qty Per Set',
    purchasingPrice: 'Purchase Price',
    salePrice: 'Sale Price',
    salesConnection: 'ASIN/Sale Connection',
    distributionMaterialCount: 'Delivery Material',
    productLotCount: 'Hands Producet Number',
    customsCode: 'Declaration Code',
    isCharged: 'Is it Charged',
    destinationPortCustomsClearanceCode: 'Customs Code',
    declaredPrice: 'Declared Price',
    imgUrl: 'Image URL',
    customsDeclaredPriceListHtml: 'Declared Value',
    sellPriceScreenshot: 'Sales Screenshot',
    incomeScreenshot: 'Earnings Screenshot',
    declared_price_tips: 'Please fill in the declared price correctly',
    customs_code_area_tips:
      'Please fill in the customs clearance code of the port of destination correctly'
  },
  pickUpAddress: {
    title: 'Pickup Address',
    linkMan: 'Contact',
    contactWay: 'Phone',
    provinces: 'State',
    address: 'Address',
    default: 'Default Address',
    defaultValue: 'Default',
    setDefault: 'Set As Default',
    add: 'Add a pickup address'
  },
  shippToAddress: {
    title: 'Common Delivery Address',
    addTitle: 'Add A Common Delivery Address',
    customerDeliveryCompany: 'Company',
    personal: 'Personal',
    customerDeliveryAddressAttn: 'Contact',
    customerDeliveryAddressPhone: 'Phone',
    city: 'City',
    state: 'State',
    zipCode: 'PostalCode',
    address: 'AddressLine1',
    address2: 'AddressLine2',
    countryId: 'Country',
    customerDeliveryAddressEmail: 'Email',
    state_limit:
      'The length of the province and state cannot be greater than 3',
    size_limit: 'Maximum 100 delivery addresses are allowed'
  },
  invoice: {
    title: 'Invoice',
    invoiceName: 'Name',
    type: 'Type',
    invoiceBankName: 'Bank Name',
    inviIdentificaNumber: 'Identification Number',
    invoiceAccount: 'Bank Account',
    invoicePhone: 'Phone',
    invoiceReceivePhone: 'Notifier Phone',
    invoiceAddress: 'Address',
    invoiceReceiveEmail: 'Notifier Email',
    isdefault: 'Default',
    setDefault: 'Set As Default'
  },
  /**
   * 进口商
   */
  importer: {
    title: 'Importer',
    importerCompany: 'Company',
    importerAttn: 'Contact',
    zipCode: 'PostalCode',
    importerCountry: 'Country',
    importerPhone: 'Phone',
    importerAddress: 'Address',
    importerMail: 'Mail',
    defaultValue: 'Default',
    select: 'Select Importer',
    isVatAndEori: 'Own VAT and EORI',
    vat_and_eori: 'Own VAT and EORI',
    companyName: 'Importer company name',
    importerLinkMan: 'Contact',
    importerCompanyName: 'Company Name',
    contact: 'Contact',
    phone: 'Phone',
    address: 'Address',
    mail: 'mail',
    zipCode: 'PostalCode',
    country: 'Country',
    selected_jf_importer: 'JF importer have been selected',
    select_jf_importer: 'Select JF importer',
    create: 'Create',
    selected: 'Selected',
    select_country: 'Select Country',
    searchCompany: 'Company',
    importerZipCode: 'PostalCode',
    isRegisterCDS: 'is Register CDS'
  },
  /**
   * 发件人
   */
  shipper: {
    title: 'ShipFrom',
    shipperCompany: 'Company(Chinese)',
    shipperCompanyCN: 'Company(English)',
    shipperAttn: 'Contact',
    shipperPhone: 'Phone',
    shipperAddress: 'Address',
    shipperZipCode: 'PostalCode',
    shipperEmail: 'Email',
    shipperEnterpriseCreditCode: 'EnterpriseCreditCode',
    defaultValue: 'Default',
    setDefault: 'Set As Default',
    state_limit:
      'The length of the province and state cannot be greater than 3',
    size_limit: 'Maximum 50 delivery addresses are allowed'
  },
  pickup: {
    title: 'Appointment pickup time',
    create: 'Create',
    schedule: 'Schedule',
    index: 'Index',
    sysRemark: 'Remark',
    cdate: 'Cdate',
    arrangementPickupDate: 'Arrange Time',
    scoreGradeName: 'Evaluate',
    cancel: 'Cancel',
    waybillNo: 'No',
    referenceNo: 'Ref',
    customerTotalPackages: 'Count',
    customerActualWeight: 'Weight(KG)',
    customerVolume: 'Volume(CMB)',
    schedulePickupName: 'Scheduled',
    takeDeliveryOfGoodsCount: 'PCS',
    takeDeliveryOfGoodsWeight: 'Weight(KG)',
    takeDeliveryOfGoodsVolume: 'Volume(CBM)',
    appointmentPickupDate: 'Pickup Date',
    addNewAdderss: 'Add Address',
    province: 'State',
    address: 'Address',
    linkMan: 'Contact',
    contactWay: 'Phone',
    save: 'Save',
    cancel: 'Cancel',
    appointmentPickupDate: 'Pickup Date',
    pickUpGoodsNum: 'No',
    takeDeliveryOfGoodsProvince: 'State',
    takeDeliveryOfGoodsCity: 'City',
    takeDeliveryOfGoodsArea: 'Area',
    takeDeliveryOfGoodsStreet: 'Street',
    takeDeliveryOfGoodsAddress: 'Address',
    takeDeliveryOfGoodsLinkMan: 'Contact',
    takeDeliveryOfGoodsLinkPhone: 'Phone',
    takeDeliveryOfGoodsLinkPhoneSpare: 'Backup Phone',
    driverName: 'Driver Name',
    driverPhone: 'Driver Phone',
    licensePlate: 'License Plate',
    pickupAddress: 'Pickup Address',
    fold: 'Fold',
    more: 'More',
    shippwayType: 'Order Type',
    tips:
      'Reminder: If you need to cancel the pickup, please call our sales staff in time. If the driver is already on the way, a return fee will be incurred',
    evaluate: 'Evaluate',
    scoreTakeDeliveryOfGood: 'Limitation',
    scoreGrade: 'Service Attitude',
    evaluate_tips: 'Are you satisfied with this delivery service?',
    one_star: 'Poor in every way',
    two_star: 'Dissatisfied,',
    three_star: 'Need to improve',
    four_star: 'Can still be improved',
    five_star: 'Impeccable',
    check_address_error1: 'Please select a pickup address!',
    check_address_error2: 'Please fill in the pickup address!',
    cancel_pickup_confirm: 'Are you sure you want to cancel the pickup?',
    submit_appraised_error:
      'Service attitude and delivery time must be evaluated',
    submit_pickup_error: 'Please select the waybill first'
  },
  port2port: {
    title: 'Port to port Order',
    shippingWay: 'Shipping Method',
    AIR: 'AIR',
    FCL: 'FCL',
    lcl: 'LCL',
    countryId: 'country',
    shipmentPort: 'Shipment Port',
    destinationPort: 'Destination Port',
    customerActualWeight: 'Weight',
    customerTotalPackages: 'PCS',
    customerVolume: 'Volume',
    isCustomerDeclaration: 'Declare',
    isCustomerDeclaration_tips1:
      'It refers to the situation where you designate a company with import and export rights for export declaration, can provide a complete set of customs declaration documents by yourself, and do export tax rebates in the future. Please select yes. If this is not the case, please select No.',
    isCustomerDeclaration_tips2:
      'If some of your goods in this shipment need to use general trade customs declaration, and other parts do not need general trade customs declaration, please select the "Partial customs declaration" option.',
    cabinetNumber: 'Cabinet Number',
    cabinetType: 'Cabinet Type',
    isCustomerDeclaration: 'File Upload',
    selectFile: 'Select Upload',
    loadingMethod: 'Loading Method',
    loadingJF: 'Loading By JF',
    loadingAddress: 'Loading Address',
    customerDelivery: 'Customer Delivery',
    loadingCustomer: 'Customer Loading',
    isBuyInsurance: 'Buy Insurance',
    totalPurchasingPrice: 'Purchasing Price',
    nameDescription: 'Name Description',
    selectImporter: 'Select Importer',
    addImporter: 'Add Importer',
    importerCompanyName: 'Company Name',
    importerLinkMan: 'Contact',
    importerPhone: 'Phone',
    importerZipCode: 'PostalCode',
    vat: 'VAT',
    eori: 'EORI',
    importerAddress: 'Address',
    importerMail: 'Mail',
    draft: 'Draft',
    ship: 'Ship',
    back: 'Back',
    customerRemark: 'Remark',
    referenceNo: 'Ref No',
    custoemrSenderId: 'Shipper Company',
    shipperCompany: 'Shipper Company(English)',
    shipperAttn: 'Shipper Contact',
    shipperPhone: 'Shipper Phone',
    shipperAddress: 'Shipper Address',
    masterNumberNotifier: 'Alert',
    houseNumberReceiver: 'Consignee',
    senderAdress: 'Address(English)',
    senderEnterpriseCreditCode: 'Credit Code',
    senderZipCode: 'PostalCode',
    senderPhone: 'Phone',
    senderLinkMan: 'Contact',
    senderCompanyCN: 'Company(Chinese)',
    senderCompany: 'Company(English)',
    selectTimePeriod: 'Select Time Period',
    selectDate: 'Select Date',
    etInStock: 'Loading Time',
    fold: 'Fold',
    more: 'More',
    addPicupkAddress: 'Add',
    area: 'Area',
    address: 'Address',
    linkMan: 'Contact',
    contactWay: 'Phone',
    loading_tips:
      'If the loading time is not within the loading time, you need to contact the corresponding sales in advance and notify the nine parties to make preparations for receiving the goods.',
    referenceNo_tips:
      'Any number that you can use to identify this waybill yourself.',
    referenceNo_validate:
      'Please fill in English, numbers or -, no more than 50 characters',
    masterNumberNotifier: 'Alert',
    houseNumberReceiver: 'Consignee',
    houseNumberReceiver_formate:
      'Company English name, Company English address, TEL: Contact number, VAT: separated by line breaks',
    insurance_tips1: '1、Do not fill in the default do not buy insurance',
    insurance_tips2:
      '2、If you fill in the value of the goods, Jiufang buys insurance, buys insurance according to the value of the goods, and only compensates 90% of the value of the goods. When making a claim, you need to provide a purchase invoice, whichever is lower to calculate the compensation amount, and the maximum compensation is RMB50',
    insurance_terms1:
      '1、Party A shall pay the insurance premium to Party B according to 0.3% of the purchase value of the product;',
    insurance_terms2:
      '2、Compensation for the purchase value of the product provided when placing the order in the system;',
    insurance_terms3:
      '3、There is no deductible, that is, the compensation is based on 100% of the purchase value of the product. The purchase invoice needs to be provided when the claim is settled, and the compensation amount is calculated according to which one is lower.',
    insurance_terms4:
      ' 4、Compensation upper limit: RMB 2 million/container for the whole container by sea',
    loading_method_tips1:
      'Jiufang loading: Jiufang picks up the goods at the customer loading address and delivers to the port of departure',
    loading_method_tips2:
      'Customer loading: the customer will deliver the goods to the port of departure within the loading time',
    buy_insurance_tips1: 'a Buy insurance is Yes:',
    buy_insurance_tips2:
      '1、Party A shall pay the premium to Party B according to 0.3% of the purchase value of the product;',
    buy_insurance_tips3:
      '2、Compensation for the purchase value of the product provided when placing the order in the system;',
    buy_insurance_tips4:
      '3、There is no deductible, that is, the compensation is based on 100% of the purchase value of the product. The purchase invoice needs to be provided when the claim is settled, and the compensation amount is calculated according to which one is lower;',
    buy_insurance_tips5:
      '4、Compensation upper limit: RMB 2 million/container for the whole container by sea',
    buy_insurance_tips6: 'b Buy insurance is No:',
    buy_insurance_tips7:
      '1. If you do not fill in, you will not buy insurance by default;',
    buy_insurance_tips8:
      '2. If you fill in the value of the goods, the nine parties will buy insurance, buy insurance according to the value of the goods, and only compensate 90% of the value of the goods. When making a claim, you need to provide a purchase invoice, whichever is lower to calculate the compensation amount, and the maximum compensation is RMB500,000/ cabinet.',
    customer_declaration_tips1:
      'It refers to the situation where you designate a company with import and export rights for export declaration, can provide a complete set of customs declaration documents by yourself, and do export tax rebates in the future. Please select yes. If this is not the case, please select No.',
    customer_declaration_tips2:
      'If some of your goods in this shipment need to use general trade customs declaration, and other parts do not need general trade customs declaration, please select the "partial customs declaration" option.',
    select_sender_company_tips:
      'The sender company info that has been filled in will be cleared?',
    cabinet_type_tips:
      'Please fill in the current cabinet type before adding new ones',
    default_buy_insurance: 'No insurance by default!'
  },
  detail: {
    title: 'waybill Detail',
    evaluation: 'Evaluation',
    channel: 'Basic',
    sender: 'ShipFrom',
    importer: 'Importer',
    dispatch: 'ShipTo',
    fee: 'Fee',
    problem: 'Problem',
    invoice: 'Liquidation Invoice',
    packing: 'Packing List',
    packingListOld: 'View original packing list data',
    total: 'Total',
    inStockActualWeight: 'Weight',
    inStockVolume: 'Volume',
    inStockVolumeWeight: 'Volume Weight',
    inStockChargedWeight: 'Billing Weight',
    file: 'File List'
  },
  head: {
    index: 'Index',
    opt: 'Operate',
    costNames: 'Fee name',
    totalCost: 'Amount',
    remain: 'Remain',
    currency: 'currency',
    startNumNo: 'BoxNo',
    trackNumber: 'Track Number',
    trackType: 'Track Type',
    weight: 'Weight(kg)',
    LWH: 'Length×Width×Height(cm)',
    totalVolum: 'Volume',
    volumeWeight: 'Volume Weight',
    chargedWeight: 'Billing weight',
    sku: 'SKU',
    num: 'Num',
    oldWeight: 'Weight(kg)',
    oldLength: 'Length(cm)',
    oldWidth: 'Width(cm)',
    oldHeight: 'Height(cm)',
    problemType: 'Problem Type',
    problemDescribe: 'Problem Describe',
    process: 'Process',
    shipmentId: 'Shipment ID',
    referenceId: 'Reference ID',
    declareNameEn: 'Product name(EN)',
    declareNameCn: 'Product name(CN)',
    declareName: 'Product name',
    brand: 'Brand',
    material: 'Material',
    purpose: 'Purpose',
    customsCode: 'Declaration Code',
    customsClearanceCode: 'Customs Code',
    asin: 'ASIN/sSales link',
    asindeclareValue: 'ASIN Selling Price',
    isCharged: 'charged',
    model: 'Model',
    num: 'Qty',
    measurementUnit: 'Unit',
    perSuitNum: 'Qty per set',
    purchasingPrice: 'Purchasing Price(RMB)',
    distributionMaterialCount: 'Delivery Material',
    productLotCount: 'Hands Producet Number',
    imgUrl: 'Image',
    sellPriceScreenshot: 'Sales Screenshot',
    incomeScreenshot: 'Earnings Screenshot',
    declareValue: 'Declare Value',
    waybillNo: 'waybillNo',
    referenceNo: 'Ref No.',
    onlineInquiryNo: 'OnlineInquiry No',
    statusName: 'Status',
    storageLocationName: 'Place of receipt',
    trackNumber: 'TrackNumber1',
    trackNumber2: 'TrackNumber2',
    countryName: 'Country',
    dispatchAddressCode: 'Delivery Address',
    customerChannelMap: 'Inbound channel',
    totalDeclareValueStr: 'Total Declare Value',
    customerActualWeight: 'Weight',
    instockCustomerActualWeight: 'Inbound Weight',
    customerVolume: 'Volume',
    instockCustomerVolume: 'Inbound Volume',
    customerChargedWeight: 'Charged Weight',
    instockCustomerChargedWeight: 'Inbound Charged Weight',
    customerTotalPackages: 'PCS',
    inStockTotalPackages: 'Inbound PCS',
    inStockTime: 'Inbound Time',
    outStockTime: 'Outbound Time',
    channelCapacity: 'Channel Capacity',
    countryStateName: 'Domestic Division',
    abroadWaybillNo: 'Overseas Waybill',
    bankStatementAmount: 'Amount',
    statementStatusName: 'Status',
    rechargePicture: 'Recharge picture',
    customerRemark: 'Remark',
    accountName: 'AccountName',
    bankName: 'BankName',
    address: 'Address',
    accountNo: 'AccountNo',
    masterNo: 'MasterNo',
    customerShortName: 'Customer Name',
    countryName: 'Return country',
    serviceItemName: 'Service Item',
    salesmanName: 'Sale',
    servicesName: 'Service',
    cuserName: 'Creator',
    seaAirWaybillNo: 'FBA Waybill',
    returnCountry: 'ReturnCountry',
    serviceArr: 'Service Item',
    statusName: 'Status',
    salesmanId: 'Sale',
    servicesId: 'Service',
    cuser: 'Creator',
    returnBatchIndex: 'Return Batch',
    returnNo: 'Return No',
    trackNo: 'Return TrackNo',
    shipmentId: 'Shipment ID',
    cartons: 'Cartons',
    receiptDate: 'Signed Date',
    receiptPallets: 'Number of pallets signed',
    receiptCartons: 'Number of signed boxes',
    oldsku: 'old FNSKU',
    receiptQuantity: 'Number of signed',
    receiptCondition: 'Receipt (whether it is damaged or not)',
    customsCodeListHtml: 'Customs Clearance Code',
    customsDeclaredPriceListHtml: 'Declared Price',
    accountName: 'AccountName',
    bankName: 'BankName',
    address: 'address',
    accountNo: 'AccountNo',
    bankStatementAmount: 'Flow Amount',
    statementStatusName: 'Status',
    rechargePicture: 'Recharge picture',
    customerRemark: 'Remark',
    abroadStockAddress: 'Abroad Stock Address',
    consignee: 'Consignee',
    phone: 'Phone',
    productNum: 'Product Qty',
    weight: 'Weight',
    storeAddress: 'Store Address',
    fnSku: 'fnSku',
    name: 'Name',
    link: 'Link',
    download: 'Download',
    cdate: 'Create Time',
    salePrice: 'Sale Price',
    returnBatchIndexName: 'Return batch',
    cartonNo: 'Carton No',
    boxNo: 'Box No',
    instockCustomerWeight: 'Weight',
    instockCustomerLength: 'Length',
    instockCustomerWidth: 'Width',
    instockCustomerHeight: 'Height',
  },
  abroad: {
    check: 'Confirm the current waybill',
    close: 'Delete the current waybill',
    servicesId: 'Service',
    salesmanId: 'Sale',
    masterNo: 'Master Order number',
    waybillNo: 'waybill No',
    status: 'status',
    return: 'Call back the current waybill',
    edit: 'Edit',
    file: 'file list',
    fileType: 'File type',
    fileName: 'File name',
    fileOpt: 'Operation',
    batchNo: 'Operation batch',
    basic: 'Basic information',
    returnCountry: 'Return Country',
    customerRemark: 'Consignment note',
    serviceItemArr: 'Service Item',
    OT: 'Other',
    HWC: 'Transit',
    TH: 'Return',
    shippingWay: 'Business Type',
    cargoInfo: 'Cargo Info',
    uploadDialog: 'Import cargo information',
    downloadCargoInfo: 'Export cargo information',
    change_cargo_info_error: 'Please fill in the required information',
    trackingInfo: 'Shipment tracking information',
    saveStock: 'Save the warehouse address',
    tracking_error: 'Please select the FBA warehouse address',
    dispatch_way_error: 'Please select a dispatch method',
    returnBatchIndexName: 'Return batch',
    deleteFileTips:
      'This operation will permanently delete the file, do you want to continue?',
    inventory: 'Inventory status',
    num: 'Total number of products',
    boxNum: 'Total number of boxes',
    weight: 'Total weight',
    volume: 'Total volume',
    export_inventory: 'Export inventory',
    importInStockInfo_tips:
      'The file download page has been opened for you, if the page does not jump, please check whether the pop-up window is blocked by the browser',
    operationInstruction: 'Operation instruction information',
    totalAmount0: 'Total product forecast quantity',
    totalAmount1: 'Total replacement amount',
    totalAmount2: 'Total inventory count',
    totalAmount3: 'Total maintenance quantity',
    totalAmount4: 'Total destroyed amount',
    operationInstruction_tips:
      'If you need to change the label, please provide a PDF format label',
    uploadAbroadWaybillLabelFile: 'Upload label file',
    uploadOperationInstruct: 'Batch import information',
    addReturnBatchIndex: 'Add operation batch',
    uploadLabel: 'Upload label file',
    uploadOperationInstructionData: 'Import operation instruction information',
    downOperationInstructionData: 'Export operation instruction information',
    operationInstruction: 'Operation instruction information',
    addReturnBatchIndex_confirm_tips: 'Add operation batch',
    returnInfo: 'Return tracking information',
    returnInfoTips:
      'When adding or editing a return tracking number, please export the template first, and then import it into the system. Be careful not to delete the previous information. ',
    batchDel: 'Batch delete',
    selectOpt: 'Select operation',
    returnInfoTotalAmount0: 'Total number of boxes',
    returnInfoTotalAmount1: 'Total number of products',
    returnInfoTotalAmount2: 'Total number of pallets signed',
    returnInfoTotalAmount3: 'Total number of signed boxes',
    importReturnInfo: 'Import return tracking information',
    exportReturnInfo: 'Export return tracking information',
    returnInfo: 'Return tracking information',
    select_all_tips: 'Whether to operate the selected return information',
    batch_delete_tips: 'Please select the data to delete',
    enter_select_tips: 'Please select the saved data! ',
    remark: 'Remark information',
    receive: 'Receivable information',
    confirmBill: 'Confirm Bill',
    packingListInfo: 'packing list information',
    exportPackingListInfo: 'Export Packing List Info',
    exportPackingListLabel: 'Upload the outer box label file',
    packingListTotalAmount0: 'Total number of boxes',
    packingListTotalAmount1: 'Total Amount',
    packingListTotalAmount2: 'Total weight',
    confirmPackingList: 'Confirm packing list information',
    confirm_packing_list_tips: 'Confirm the packing list information',
    batchUploadGoodsInfoData: 'Batch Upload Goods Info Data'
  },
  payment: {
    title: 'Current arrears',
    repayment: 'Repayment Information',
    bank:
      'Bank remittance (select any of the following accounts for transfer and repayment)',
    tips: 'Please contact the sales for repayment during system upgrade',
    error1: 'Please fill in the recharge amount',
    error2: 'Please fill in the correct number (only 2 decimal places)',
    record: 'Record'
  },
  hd: {
    remark: 'Remark'
  },
  mail: {
    country: 'Country',
    title: 'Customer file email notification',
    title_oversea: 'Notification Email',
    email: 'Email',
    typeName: 'File Type',
    fileType: 'File Type',
    cdate: 'Create time',
    isActive: 'Whether enabled',
    isNotice: 'Whether to notify the estimated time',
    mail_formate_error: 'Please fill in the correct email address'
  },
  /**
   * 公共
   */
  common: {
    yes: 'Yes',
    no: 'No',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    sure: 'Sure',
    query: 'Query',
    cancel: 'Cancel',
    save: 'Save',
    reset: 'Reset',
    tips: 'Tips',
    required: ' Required',
    opt: 'Operate',
    cdate: 'Creation Time',
    select: 'Select',
    delete_confirm: 'You sure you want to delete it?',
    upload_limit: 'Upload file size cannot exceed 50MB',
    upload_file_type: 'Upload files can only be jpg/png file',
    upload_fail: 'Upload Fail',
    select: 'Select',
    please_select: 'Please select ',
    please_input: 'Please enter ',
    illegal_param: 'Illegal parameter format',
    export: 'Export',
    submit_confirm: 'Submit Confirm',
    submit_approval: 'Submit Approval',
    fill: 'Please fill in the first',
    line_required: 'Line, required',
    search: 'Search',
    upload: 'Upload',
    upload_image: 'Upload Image',
    current_image: 'Current Image',
    replace_image: 'Replace Image',
    click_upload: 'Click to Upload',
    file_drag_here: ' Drag file here',
    sku_name_must_same_file_name:
      'The file name must be the same as the SKU name',
    index: 'Index',
  }
}
